module.exports = __webpack_public_path__ + "static/media/joy2.0c37d546.jpg";